import { createContext, useContext } from 'react';
import { CalibrationSuggestion, Paths } from 'talent_matching/types';

export type NudgeCalloutState = 'applied' | 'manual_review' | null;

type CalibrationModalContextType = {
  openCalibrationModal: () => void;
  closeCalibrationModal: () => void;
  showCalibrationModal: boolean;
  paths: Paths;
  jobTitle: string;
  canCreateCalibrationSetting: boolean;
  canEditAndDeleteTalentMatchingCalibration: boolean;
  nudgeCalloutState: NudgeCalloutState;
  setNudgeCalloutState: (state: NudgeCalloutState) => void;
  openNudgeReviewModal: () => void;
  pendingNudgeSuggestions: CalibrationSuggestion[] | null;
  setPendingNudgeSuggestions: (
    suggestions: CalibrationSuggestion[] | null
  ) => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const CalibrationModalContext = createContext<CalibrationModalContextType>({
  openCalibrationModal: noop,
  closeCalibrationModal: noop,
  showCalibrationModal: false,
  paths: {} as Paths,
  jobTitle: '',
  canCreateCalibrationSetting: false,
  canEditAndDeleteTalentMatchingCalibration: false,
  nudgeCalloutState: null,
  setNudgeCalloutState: noop,
  openNudgeReviewModal: noop,
  pendingNudgeSuggestions: null,
  setPendingNudgeSuggestions: noop,
});

export const useCalibrationModal = () => useContext(CalibrationModalContext);
export const CalibrationModalProvider = CalibrationModalContext.Provider;
